<template>
  <div class="pagination">
    <el-pagination
        background
        v-loading="loading"
        layout="prev, pager, next"
        @current-change="currentChange"
        :page-size="page.per_page?page.per_page:10"
        :total="page.total">
    </el-pagination>
    </div>
</template>

<script>
export default {
    props: ['loading','page'],

    methods : {
        currentChange(currentPage){
            this.$emit('current-change',currentPage);
        }
    }
}
</script>

<style>

</style>